import { useMemo } from 'react';
import { uniqueService } from '@utils/library/unique.service';

export const useUniqueId = (id?: string) => {
  const uniqueId = useMemo(() => id ?? uniqueService.getUniqueId(), [id]);

  return uniqueId;
};
